import { createSlice, current } from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";
import { FederationId } from "../../settings";

const initialState = {
  //loader
  processing: false,
  processingText: "",
  plans: [],
};

const planSlice = createSlice({
  name: "plans",
  initialState: initialState,
  reducers: {
    setInitialState: (state, action) => ({ ...initialState }), //no payload

    setProcessing: (state, action) => {
      const { processing = true, processingText = "" } = action.payload;

      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },

    plansLoaded: (state, action) => {
      const pageState = current(state);
      if (pageState.pageDisposed) return state;

      return {
        ...state,
        processing: false,
        processingText: "",
        plans: action.payload.SubscriptionPlansInfo,
      };
    },
    disposePage: (state, action) => {
      if (action.payload) return { ...initialState };
      else
        return {
          ...state,
          pageDisposed: false,
        };
    },
  },
});

export default planSlice.reducer;

export const { setInitialState, setProcessing, plansLoaded, disposePage } =
  planSlice.actions;

export const loadPlans = (t) => async (dispatch, getState) => {
  //start with initial values
  dispatch(setInitialState());

  //show loader
  dispatch(
    setProcessing({ processing: true, processingText: t("slices.loadingPlans") })
  );

  try {
    var response = await api({
      url: "subscription/getsubscriptionplansinfo",
      method: "post",
      data: {},
    });

    //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
    if (getState().plans.pageDisposed) return;
    //it's ok to dispatch here
    let data = response.data.Data;

    dispatch(plansLoaded(data));

    //add (response)
    return Promise.resolve();
  } catch (err) {
    //i am here => could be any error included 200 and Succeeded=false
    return Promise.reject(err);
  }
};
